import * as S from './style'
import * as SG from 'src/components/receivement-components/styles'

import {
  Table,
  TableBody,
  TableBodyCell,
  TableHeader,
} from 'src/components/TableComponents'
import { BatchWithoutBarcode } from 'src/features/receivement/ReceivementTypes'
import { formatNumberBR } from 'src/utils'

interface TableBatchBarcodeNotFoundProps {
  batchesNotBarcode: BatchWithoutBarcode[]
  selected?: BatchWithoutBarcode
  onSelected: (arg0: BatchWithoutBarcode) => any
}

export const TableBatchBarcodeNotFound = ({
  batchesNotBarcode,
  onSelected,
  selected,
}: TableBatchBarcodeNotFoundProps) => (
  <S.Wrapper>
    <SG.SubTitle>Lotes sem cod. barras</SG.SubTitle>
    <Table>
      <TableHeader
        columnInformation={[
          { columnName: 'ID Lote' },
          { columnName: 'Código' },
          { columnName: 'Descrição' },
          { columnName: 'Qtd. total' },
        ]}
      />
      <TableBody>
        {batchesNotBarcode.map((batch) => (
          <S.TableBodyRow
            key={String(batch.id)}
            onClick={() => onSelected(batch)}
            clicked={selected?.id === batch.id}
          >
            <TableBodyCell>{batch.id}</TableBodyCell>
            <TableBodyCell>{batch.usedBarcode}</TableBodyCell>
            <TableBodyCell>{batch.customDescription}</TableBodyCell>
            <TableBodyCell>{`${formatNumberBR(batch.total)} ${batch.isKg ? 'KG' : 'UN'}`}</TableBodyCell>
          </S.TableBodyRow>
        ))}
      </TableBody>
    </Table>
  </S.Wrapper>
)
